import { ShieldOff } from "lucide-react"
import { Link, Outlet, useLocation } from "react-router"

import { puedeAbrirRuta } from "@/lib/accesoRutas"
import { usarSesion } from "@/lib/sesion"

/**
 * La guarda de cada pantalla por su dirección (05/11): sin el permiso de su entrada del
 * menú, la pantalla NO se monta —ni su título, ni sus pestañas, ni sus columnas— y no
 * pide nada al servidor. Ver `lib/accesoRutas.ts`.
 *
 * ⚠ **Es una ruta de diseño entre el armazón y las pantallas**, no un envoltorio en
 * cada una: una pantalla nueva queda protegida sin acordarse de nada, y su regla la
 * exige `accesoRutas.test.ts`.
 */
export function GuardaDeRuta() {
  const usuario = usarSesion((e) => e.usuario)
  const { pathname } = useLocation()
  if (puedeAbrirRuta(usuario, pathname)) return <Outlet />
  return <SinAcceso />
}

function SinAcceso() {
  return (
    <div className="mx-auto max-w-md py-16 text-center" data-testid="sin-acceso">
      <ShieldOff
        size={32}
        aria-hidden={true}
        className="mx-auto"
        style={{ color: "var(--fg-muted)" }}
      />
      <h1 className="mt-3 text-lg font-semibold">No tienes acceso a esta pantalla</h1>
      <p className="mt-2 text-sm" style={{ color: "var(--fg-muted)" }}>
        Tu usuario no tiene el permiso que la abre. Si la necesitas, pídelo a quien administra los
        accesos.
      </p>
      <Link
        to="/"
        className="foco-cristal mt-4 inline-block text-sm font-medium underline-offset-2 hover:underline"
      >
        Ir al inicio
      </Link>
    </div>
  )
}
